<template>
  <v-app>
    <div id="app">
      <Navdrawer v-if="isActivated"></Navdrawer>
      <v-app-bar app fixed clipped-left color="primary">
        <v-app-bar-nav-icon v-if="isActivated" @click="navClick" color="white"></v-app-bar-nav-icon>
        <v-img class="mr-3" :src="require('./assets/logo.png')" max-height="60" max-width="60"></v-img>
        <v-toolbar-title class="headline white--text">
          <span>Life RTL</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-menu v-if="isLoggedIn" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text icon color="white" v-on="on">
              <v-icon x-large dark>expand_more</v-icon>
            </v-btn>
            <span class="white--text">{{ shortName }}</span>
          </template>
          <v-list dense>
            <v-list-item>
              <v-list-item-title>Welcome, {{ userName }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-on:click="navigateRoute('/changepassword')">
              <v-list-item-icon>
                <v-icon>lock_open</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Change Password</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isAdmin" v-on:click="navigateRoute('/admin/manageusers')">
              <v-list-item-icon>
                <v-icon>supervisor_account</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Manage Users</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isAdmin" v-on:click="navigateRoute('/admin/manageroles')">
              <v-list-item-icon>
                <v-icon>vpn_key</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Manage Roles</v-list-item-title>
            </v-list-item>
            <v-list-item v-on:click="logout">
              <v-list-item-icon>
                <v-icon>exit_to_app</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-content>
        <v-container fluid>
          <router-view></router-view>
        </v-container>
        <v-footer padless color="primary lighten-1">
          <v-row justify="center" no-gutters>
            <v-col class="primary lighten-2 py-2 text-center white--text" cols="12">
              <em>"So then faith cometh by hearing, and hearing by the word of God."</em> (Romans 10:17)
            </v-col>
            <v-col class="primary lighten-1 py-2 text-center caption white--text" cols="12">
              &copy;{{ new Date().getFullYear() }} Life Bible-Presbyterian Church. All Rights Reserved.
              <br />
            </v-col>
          </v-row>
        </v-footer>
      </v-content>
    </div>
  </v-app>
</template>

<script>
import Navdrawer from "./components/Navdrawer";

export default {
  name: "App",
  components: {
    Navdrawer,
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    isAdmin: function () {
      return this.$store.getters.isAdmin;
    },
    isActivated: function () {
      return this.$store.getters.isVerified && this.$store.getters.isActivated;
    },
    userName: function () {
      let userObj = this.$store.getters.getUser;
      if (userObj != null) {
        return userObj.preferredname;
      }
      return "";
    },
    shortName: function () {
      let userObj = this.$store.getters.getUser;
      if (userObj != null) {
        if (userObj.christianname != "") {
          return userObj.christianname;
        }
        return userObj.givenname;
      }
      return "";
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    navigateRoute(newpath) {
      this.$router.push(newpath);
    },
    navClick() {
      this.$bus.$emit("navClick", "beep");
    },
  },
};
</script>
